export default __webpack_public_path__ + "static/media/PortraitOfUs.9b684910.jpg";